export default __webpack_public_path__ + "../staticImages/winefinder-sprite-taste-03-2x.png";